/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.animatedCardSlider", {
        options: {
            slickOptions: {
                arrows: false,
                autoplay: true,
                autoplaySpeed: 8000,
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                rows: 0,
                pauseOnFocus: false,
                pauseOnHover: false,
            },
            countUpOptions: {
                duration: 2,
                useEasing: true,
                useGrouping: false,
                separator: "",
                decimal: ".",
                enableScrollSpy: true,
                scrollSpyDelay: 200,
                scrollSpyOnce: true,
            },
        },

        _create: function () {
            this.wrap = this.element.find(".b-stats-animated__content-list");
            this.countUpInstances = [];
            this.currentSlideIndex = 0;
            this.animatedSlides = new Set();
            this.isSliderInitialized = false;
            this.isInViewport = false;

            this._initCountUpFromText();

            this._setupViewportDetection();
        },

        _initSlider: function () {
            if (this.isSliderInitialized) return;

            this.isSliderInitialized = true;
            this.wrap.each((indx, el) => {
                $(el)
                    .on("init", (slick) => {
                        var dots = $(".slick-dots", $(slick.target));
                        api.fn.slickDotsInit(dots, this.options.slickOptions.autoplaySpeed / 1000);
                    })
                    .slick(this.options.slickOptions)
                    .on("beforeChange", (event, slick, currentSlide, nextSlide) => {
                        var dots = $(".slick-dots", $(event.target));
                        api.fn.slickDotsFilled(dots, nextSlide);

                        this.currentSlideIndex = nextSlide;

                        this._disableScrollSpyForSlide(currentSlide);
                    })
                    .on("afterChange", (event, slick, currentSlide) => {
                        setTimeout(() => {
                            this._enableScrollSpyForSlide(currentSlide);
                        });
                    });
            });
        },

        _setupViewportDetection: function () {
            const self = this;

            if ("IntersectionObserver" in window) {
                const observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            if (entry.isIntersecting && !self.isInViewport) {
                                self.isInViewport = true;
                                self._initSlider();
                                setTimeout(() => {
                                    self._enableScrollSpyForSlide(0);
                                }, 100);
                            }
                        });
                    },
                    {
                        threshold: 0.3,
                        rootMargin: "0px 0px 0px 0px",
                    }
                );

                observer.observe(this.element[0]);
            } else {
                self._initSlider();
                setTimeout(() => {
                    self._enableScrollSpyForSlide(0);
                }, 100);
            }
        },

        _initCountUpFromText: function () {
            const self = this;
            this.element.find(".b-stats-animated__text").each(function (index) {
                const $element = $(this);
                const originalText = $element.text().trim();

                const numberMatch = originalText.match(/^(\d+(?:\.\d+)?)/);

                if (numberMatch) {
                    const targetValue = parseFloat(numberMatch[1]);
                    const suffix = originalText.replace(numberMatch[1], "").trim();
                    const decimals = numberMatch[1].includes(".") ? 1 : 0;

                    const $span = $element.find("span");
                    let spanContent = "";
                    if ($span.length) {
                        spanContent = $span.html();
                    }

                    const options = {
                        duration: self.options.countUpOptions.duration,
                        useEasing: self.options.countUpOptions.useEasing,
                        useGrouping: self.options.countUpOptions.useGrouping,
                        separator: self.options.countUpOptions.separator,
                        decimal: self.options.countUpOptions.decimal,
                        decimalPlaces: decimals,
                        enableScrollSpy: false,
                        scrollSpyDelay: self.options.countUpOptions.scrollSpyDelay,
                        scrollSpyOnce: self.options.countUpOptions.scrollSpyOnce,

                        onCompleteCallback: function () {
                            self.animatedSlides.add(index);
                            if (spanContent) {
                                const numberOnly = targetValue.toString();
                                $element.html(numberOnly + "<span>" + spanContent + "</span>");
                            } else if (suffix) {
                                $element.text(targetValue.toString() + suffix);
                            }
                        },
                    };

                    const countUpInstance = new countUp.CountUp($element[0], targetValue, options);

                    if (!countUpInstance.error) {
                        self.countUpInstances.push({
                            instance: countUpInstance,
                            element: $element,
                            slideIndex: index,
                            originalText: originalText,
                            targetValue: targetValue,
                            suffix: suffix,
                            spanContent: spanContent,
                        });
                    } else {
                        console.error("CountUp error:", countUpInstance.error);
                        $element.text(originalText);
                    }
                }
            });
        },

        _enableScrollSpyForSlide: function (slideIndex) {
            if (this.animatedSlides.has(slideIndex)) return;

            this.countUpInstances.forEach((item) => {
                if (item.slideIndex === slideIndex) {
                    item.element.text("0");

                    const updatedOptions = {
                        ...item.instance.options,
                        startVal: 0,
                        enableScrollSpy: true,
                        scrollSpyOnce: true,
                    };

                    item.instance = new countUp.CountUp(item.element[0], item.targetValue, updatedOptions);

                    if (typeof window !== "undefined") {
                        item.instance.handleScroll(item.instance);
                    }
                }
            });
        },

        _disableScrollSpyForSlide: function (slideIndex) {
            this.countUpInstances.forEach((item) => {
                if (item.slideIndex === slideIndex) {
                    item.instance.options.enableScrollSpy = false;
                }
            });
        },
    });
})(jQuery);
